export * from './lib/material.module';
export * from './lib/services/svg-icon.service';
